/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {TabsModule} from 'ngx-bootstrap/tabs';

import {ApiModule} from '../api/api.module';
import {EmployeesListModule} from '../employees-list/employees-list.module';
import {EmployeesSharedModule} from '../employees/employees-shared.module';
import {PipesModule} from '../pipes/pipes.module';
import {UiModule} from '../ui/ui.module';

import {ContractEmployeeMenuComponent} from './contract-employee-menu.component';

@NgModule({
  imports: [
    ApiModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    UiModule,
    EmployeesSharedModule,
    EmployeesListModule,
    PipesModule,
    TabsModule
  ],
  declarations: [
    ContractEmployeeMenuComponent
  ],
  exports: [
    ContractEmployeeMenuComponent
  ]
})

export class ContractEmployeeMenuModule {
}
